module.exports = __webpack_public_path__ + "img/hospital13.852a9657.png";